// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoutButton {
  position: absolute;
  right: 10px;
  display: flex;
  gap: 30px;
}
.logoutButton p {
  color: gray;
}
.logoutButton button {
  color: white;
}

.mobileMenuButton {
  color: white;
  text-decoration: none;
}

.mainDiv a {
  text-decoration: none;
}

a.active {
  border-bottom: 2px solid #51479f !important;
}

button.active {
  border-bottom: 2px solid #51479f !important;
}

@media (max-width: 850px) {
  .logoutButton {
    gap: 20px;
  }
  .logoutButton button {
    display: none;
  }
  .logoutButton p {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/elements/menu/menu.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AACJ;AACI;EACI,WAAA;AACR;AAII;EACI,YAAA;AAFR;;AAMA;EACI,YAAA;EACA,qBAAA;AAHJ;;AAOI;EACI,qBAAA;AAJR;;AASA;EACI,2CAAA;AANJ;;AAQA;EACI,2CAAA;AALJ;;AAQA;EACI;IACI,SAAA;EALN;EAOM;IACI,aAAA;EALV;EAQM;IACI,eAAA;EANV;AACF","sourcesContent":[".logoutButton {\n    position: absolute;\n    right: 10px;\n    display: flex;\n    gap: 30px;\n\n    p {\n        color: gray;\n    }\n\n    ;\n\n    button {\n        color: white;\n    }\n}\n\n.mobileMenuButton {\n    color: white;\n    text-decoration: none;\n}\n\n.mainDiv {\n    a {\n        text-decoration: none;\n    }\n\n}\n\na.active {\n    border-bottom: 2px solid #51479f !important;\n}\nbutton.active {\n    border-bottom: 2px solid #51479f !important;\n}\n\n@media (max-width: 850px) {\n    .logoutButton {\n        gap: 20px;\n\n        button {\n            display: none;\n        }\n\n        p {\n            font-size: 14px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
